import React from 'react';

import { IconComp } from '../IconComponent';
import { ReactComponent as MisSymbol } from '../../../assets/svg/icons/mis-symbol.svg';
import { ReactComponent as IconLightning } from '../../../assets/svg/icons/icon-lightning.svg';
import fallback from '../../../assets/fallback-image.png';
import { useBreakpoint } from '../../../hooks/useBreakpoint';
export interface IHordeMember {
  name: string;
  role: string;
  imageURL: string;
}
export interface IHordeMembers {
  title: string;
  description: string;
  members: IHordeMember[];
}

export const HordeMembers: React.FC<IHordeMembers> = (props) => {
  const { title, description, members } = props;

  const isDesktop = useBreakpoint('75em');
  return (
    <section className="app-container mx-auto relative max-w-71.5 px-2 py-8.75 text-center">
      <IconComp
        className="absolute -top-4 lg:-top-12 transform rotate-12 h-auto left-1/2 lg:left-1/5 translate-x-1/2"
        icon={MisSymbol}
        size={isDesktop ? 198 : 100}
      />
      <IconComp
        className="absolute -bottom-10 transform rotate-6 h-auto right-0 -translate-x-1/2"
        icon={IconLightning}
        size={150}
      />
      <h4 className="text-display-md mb-2.25">{title}</h4>
      <p className="text-cloud-800 text-lg mb-9 max-w-43 mx-auto">{description}</p>
      <div className="flex flex-wrap gap-x-10 gap-y-3">
        {members &&
          members.map((member, index) => (
            <figure key={index} className="flex flex-col items-center justify-between mx-auto">
              <div className="horde-member-image border border-cloud-900 flex items-center justify-center w-14.625 h-14.625 rounded-full overflow-hidden bg-cloud-300 mb-3">
                <img
                  onError={({ currentTarget }): void => {
                    currentTarget.onerror = null;
                    currentTarget.src = fallback;
                  }}
                  className="w-full h-full object-cover"
                  src={member.imageURL}
                />
              </div>
              <figcaption>
                <p className="text-cloud-900 font-bold text-lg mb-1">{member.name}</p>
                <p className="text-cloud-900 text-md">{member.role}</p>
              </figcaption>
            </figure>
          ))}
      </div>
    </section>
  );
};
